import React, { useEffect, useRef, useState } from "react";
import classes from "./GalleryList.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import GalleryCard from "./gallery-card/GalleryCard";
import { Autoplay, Pagination } from "swiper/modules";
import { useLocation, useNavigate } from "react-router-dom";
import { repeatObjects } from "../Branch-Carousel/BranchCarousel";
import { NavigationContext } from "../../../App";
import { useContext } from "react";

export const textasa = "hi";

const GalleryList = ({ data }) => {
  const swiperRef = useRef(null);
  const width = useDeviceWidth();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const [isAutoplayRunning, setIsAutoplayRunning] = useState(true);
  const divRef = useRef(null);
  const [widthValue, setWidthValue] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  useEffect(() => {
    const calculateWert = () => {
      const vw = window.innerWidth; // Get the width of the viewport in pixels
      const result = 0.91 * vw - 100; // Perform the calculation
      setWidthValue(result); // Update the state
    };

    // Initial calculation
    calculateWert();

    // Recalculate on window resize
    window.addEventListener("resize", calculateWert);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", calculateWert);
    };
  }, []);

  const toggleAutoplay = () => {
    if (swiperRef.current) {
      if (isAutoplayRunning) {
        swiperRef.current.autoplay.stop(); // Stop autoplay
      } else {
        swiperRef.current.autoplay.start(); // Start autoplay
      }
      setIsAutoplayRunning(!isAutoplayRunning);
    }
  };

  console.log("width value is", widthValue);

  return (
    // <div className={`${classes.outer} bg-primary-100`}>
    <div className={`${classes.outer}`}>
      <div className={`${classes.inner} bg-primary-500`}>
        <img src="/img/gallery-pattern.svg" className={classes.pattern} alt="pattern"></img>
        <div className={classes.innerContent}>
          <div
            className={classes.title}
            ref={divRef}
            data-aos="fade-down"
            data-aos-delay="200"
          >
            <h1 className="primary-300">{data?.subTitle}</h1>
            {data?.showTitle && (
              <div
                style={{
                  width: width < 769 && "80%",
                  textAlign: width < 769 && "center",
                }}
              >
                <h2 dangerouslySetInnerHTML={{ __html: data?.title }}></h2>
              </div>
            )}
            {/* <div className={`${classes.underLine} bg-secondary-200`}></div> */}
          </div>
          <div className={classes.sliderOuter}>
            <div className={classes.arrowDiv}>
              <img
                src="/img/white-title-symbol.svg"
                alt="symbol"
                className={classes.titleSymbol}
              ></img>
              <div className={classes.arrows}>
                <img
                  className={classes.pauseIcon}
                  onClick={toggleAutoplay}
                  alt="play-icon"
                  src={
                    isAutoplayRunning
                      ? "/img/pause-icon.svg"
                      : "/img/play-icon.svg"
                  }
                />
              </div>
            </div>
            <div className={`${classes.swiperOuter} outer-outer`}>
              <div>
                {/* Custom Navigation Arrows */}

                {/* Swiper */}
                <Swiper
                  //   modules={[Navigation, Pagination]}
                  slidesPerView={
                    width > 1700
                      ? 7
                      : width > 1350
                      ? 5
                      : width > 960
                      ? 4
                      : width > 700
                      ? 3.5
                      : 2
                  } // Show 3 images at a time
                  modules={[Autoplay]}
                  speed={5000}
                  autoplay={{
                    delay: 0, // 3 seconds
                    disableOnInteraction: false, // Autoplay continues even after interaction
                  }}
                  spaceBetween={20} // Add space between slides
                  onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
                  pagination={{ clickable: true }} // Enable clickable dots
                  loop={true} // Enable infinite looping
                  draggable={true} // Enable drag/swipe functionality
                >
                  {repeatObjects(data?.listingItems,8)?.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <GalleryCard data={slide} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
          <div className={classes.showMore}>
            <button
              className="primary-hover"
              data-aos="fade-right"
              data-aos-delay="200"
              onClick={()=>{
                const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              setIsBackNavigation(true)
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
                navigate('/gallery')}}
            >
              View More Success Stories
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryList;
